import React, { useEffect, useState, useRef, useCallback } from "react";

import { Tooltip } from "@mui/material";
import "../styles/VideoPlayerV2Styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import querySend from "../assets/images/querysend.png";
import { FaRedo } from "react-icons/fa";
import infoApprove from "../../../assets/images/recommandation/approveInfo.png";
import infoReject from "../../../assets/images/recommandation/rejectInfo.png";
import infoReview from "../../../assets/images/recommandation/infoReview.png";
import downloadArrow from "../../../assets/images/recommandation/downloadArrow.png";
import jozunaIcon from "../../../assets/images/recommandation/blueJozunalogo.png";
import quizText from "../../../assets/images/popQuiz/Quick Quiz.png";
import QuizImg from "../../../assets/images/popQuiz/popQuizImg.png";
import infoImage from "../../../assets/images/recommandation/resourceInfo.png";
import PDFIcon from "../../recommendation/assets/images/pdf.png";
import inReviewImg from "../assets/images/inreview.png";
import approveImg from "../assets/images/approvedquery.png";
import rejectImg from "../assets/images/rejectquery.png";

import { useDispatch, useSelector } from "react-redux";
import { useApi } from "../../../service/ApiContext";
import { QuizData } from "../../recommendation/vedio-recommendation/data/response/popQuizResponse";
import { FullVideoResponse } from "../../recommendation/vedio-recommendation/data/response/FullVideoResponse";
import {
  QueryItem,
  QueryResponse,
} from "../../recommendation/vedio-recommendation/data/response/getQueryResponse";
import { RootState } from "../../../store/store";
import { useAlert } from "../../../components/AlertContextComponent";
import PopQuizApiCall from "../../recommendation/vedio-recommendation/data/api_services/PopquizApicall";
import Logger from "../../../utils/Logger";
import {
  setQuizComponentActive,
  setQuizOverlayActive,
} from "../../recommendation/vedio-recommendation/data/redux/QuizLogoutRedux";
import {
  setNextVideo,
  setReplay,
  setShowNextVideo,
} from "../../recommendation/vedio-recommendation/data/redux/popQuizRedux";
import strings from "../../../utils/Strings";
import Loader, { LocalStorage } from "../../../utils/Utils";
import VideoLandingPageClient from "../data/api_client/LearningRoom_Landing_ApiClient";
import { PostQueryResponse } from "../../recommendation/vedio-recommendation/data/response/postQueryResponse";
import { PostWatchTimeResponse } from "../../recommendation/vedio-recommendation/data/response/PostWatchTimeResponse";
import PDFStreamViewer, {
  PDFStreamViewerHandle,
} from "../../../components/PDFStreamerViewer";
import RecommendationViewHeader from "../../recommendation/recommendation_industry_view/components/Recommendation_View_Header";
import GreyHorizontalDivider from "./GreyDividerComponent";
import QuizPopUpLogout, {
  CopyRightPopup,
} from "../../../components/QuizPopUpLogout";
import logoutUser from "../../../features/sideBar/data/api_services/LogoutApi";
import QuizPopUp from "../../../components/QuizPopUp";
import QuizComponent from "../../recommendation/vedio-recommendation/components/QuizComponent";
import CommonUtils from "../../../utils/Common_Utils";
import AutoLinkText from "../../recommendation/vedio-recommendation/components/AutoLinkText";
import OverlayComponent from "../../recommendation/vedio-recommendation/components/OverlayComponent";
import SuccessInfoPopup from "../../../components/successInfoComponent";
import LearningRoomViewHeader from "./LearningRoomViewHeader";
import { useCamera } from "../../assessment/components/CameraContext";

// Declare VdoPlayer interface
declare global {
  interface Window {
    VdoPlayer: {
      getInstance: (iframe: HTMLIFrameElement) => {
        video: {
          addEventListener: (event: string, callback: () => void) => void;
          removeEventListener: (event: string, callback: () => void) => void;
          currentTime: number;
          playbackRate: number;
        };
        api: {
          getTotalPlayed: () => Promise<number>;
          seek: (time: number) => Promise<void>;
          play: () => Promise<void>;
        };
      };
      seek: (position: number) => Promise<void>;
    };
  }
}

const VideoPlayerV2Component: React.FC = () => {
  const api = useApi();
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Refs and state
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const videoContainerRef = useRef<HTMLDivElement | null>(null);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [showAlertForNoQuiz, setShowAlert] = useState(false);
  // At the top of your component
  const playerInstanceRef = useRef<any>(null);
  const shouldTrackWatchTimeRef = useRef(false);
  const isUserSeekingRef = useRef(false);
  const isInitialSeekRef = useRef(true);
  const [iframeLoading, setIframeLoading] = useState(true);

  const [quizData, setQuizData] = useState<QuizData | null>(null);
  const [selectedVideo, setSelectedVideo] = useState<FullVideoResponse | null>(
    null,
  );
  const [playingList, setPlayingList] = useState<FullVideoResponse[]>(
    state?.video_list?.map((video: FullVideoResponse) => video),
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [simmer, setSimmer] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isIconVisible, setIsIconVisible] = useState(true);
  const [activeTab, setActiveTab] = useState("Resources");
  const [qaList, setQaList] = useState<(QueryItem & { isMyQuery: boolean })[]>(
    [],
  );
  const [showNotification, setShowNotification] = useState<string | null>(null);
  const [question, setQuestion] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [showWaterMark, setShowWatermark] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [copyRightPopUp, setCopyRightPopUp] = useState(false);
  const [showQuizComponent, setShowQuizComponent] = useState(false);
  const autoLogoutActive = useSelector(
    (state: RootState) => state.QuizLogout.autoLogoutActive,
  );
  const [popshowAlert, setpopShowAlert] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [expandedQueries, setExpandedQueries] = useState<
    Record<string, boolean>
  >({});
  const [timestamp, setTimestamp] = useState(new Date());
  const [position, setPosition] = useState<{ top: string; left: string }>({
    top: "10%",
    left: "10%",
  });
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Constants
  const MAX_LENGTH = 100;
  const maxChars = 500;

  // Watch time tracking variables
  // Replace global variables with refs
  const watchTimeRef = useRef(0);
  const lastTimeRef = useRef(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const watchTimeVideoId = useRef<string | null>();

  // Selectors
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const replay = useSelector((state: RootState) => state.quizReducer.replay);
  const nextVideo = useSelector(
    (state: RootState) => state.quizReducer.nextVideo,
  );

  const quizComponentActive = useSelector(
    (state: RootState) => state.QuizLogout.quizComponentActive,
  );
  // 2. Modify handleVideoEnd to use ref for current video state
  const videoStateRef = useRef<FullVideoResponse | null>(null);

  const { showAlert } = useAlert();
  const { stopCamera } = useCamera();
  const { getQuizData } = PopQuizApiCall();

  const buildPlayerUrl = (video: FullVideoResponse = selectedVideo!) => {
    const params = new URLSearchParams({
      otp: video.video_otp,
      playbackInfo: video.playback_info,
      primaryColor: "FF5733",
      controls: "1",
    });

    return `https://player.vdocipher.com/v2/?${params.toString()}`;
  };

  const handleVideoSelect = async (video: FullVideoResponse) => {
    Logger.info("Inside video select");
    setShowQuiz(false);
    setShowQuizComponent(false);
    setShowQuizGradedComponent(false);
    setLoading(true);
    setShowMarkAsCompleted(false);
    // setHasReachedPDFEnd(false);
    setPdfArtifactId(null);
    // Reset tracking state
    shouldTrackWatchTimeRef.current = false;
    watchTimeRef.current = 0;
    isUserSeekingRef.current = false;
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    lastTimeRef.current = 0;
    isInitialSeekRef.current = false;

    try {
      // Load new video data
      await getFullVideo(video.video_id);

      // If switching to video, let the existing useEffect handle player initialization
      if (video.content_type === "video") {
        // Reset iframe source to trigger new player load
        if (iframeRef.current) {
          iframeRef.current.src = buildPlayerUrl(video);
        }

        // Set a flag to prevent immediate player access
        playerInstanceRef.current = null;

        // Small delay to allow iframe to start loading
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      Logger.error("Error in handleVideoSelect:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const handleFileSelect = async (video: FullVideoResponse) => {
    Logger.info("Inside file select");

    setShowQuiz(false);
    setShowQuizComponent(false);
    setShowQuizGradedComponent(false);
    setLoading(true);
    setShowMarkAsCompleted(false);
    // setHasReachedPDFEnd(false);
    setPdfArtifactId(null);
    try {
      // Load new video data and WAIT for it to complete
      await getFullVideo(video.video_id);
    } catch (error) {
      Logger.error("Error in handleVideoSelect:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // State to track if we should count watch time
  // Fixed startTracking using event listeners
  const startTracking = useCallback(() => {
    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const callThreshold = 20;
    Logger.info("Start Tracking - Player Ready:", !!playerInstanceRef.current);
    Logger.info("IntervalRef Inside StartTracking:", intervalRef.current);
    Logger.info(
      "shouldTrackWatchTimeRef Inside StartTracking:",
      shouldTrackWatchTimeRef.current,
    );
    Logger.info("WatchTimeRef Inside StartTracking:", watchTimeRef.current);

    intervalRef.current = setInterval(() => {
      // clearInterval(intervalRef.current!);
      // intervalRef.current = null;

      if (shouldTrackWatchTimeRef.current && playerInstanceRef.current) {
        watchTimeRef.current += 1;
        const playbackRate = playerInstanceRef.current.video.playbackRate;
        Logger.info(
          "WatchTimeRef Inside SetInterval StartTracking:",
          watchTimeRef.current,
        );

        Logger.info("IntervalRef Current:", intervalRef.current);
        Logger.info(
          `Tracking - Time: ${watchTimeRef.current}, Rate: ${playbackRate}`,
        );
        Logger.info(
          "WatchTimeRef and Playback",
          watchTimeRef.current * playbackRate,
        );

        if (watchTimeRef.current * playbackRate === callThreshold) {
          everySecondApiCall();
        }
      }
    }, 1000);
  }, []);
  const quizOverlayActive = useSelector(
    (state: RootState) => state.QuizLogout.quizOverlayActive,
  );
  const handleVideoEnd = useCallback(async () => {
    dispatch(setQuizOverlayActive(true));
    stopTracking();

    Logger.info("Handling video end", quizOverlayActive);
    // Always get fresh reference to current video
    const currentVideo = videoStateRef.current;
    if (videoStateRef.current?.has_quiz === true) {
      const params = {
        program_id: state.program_id,
        course_id: state.course_id,
        topic_id: state.topic_id,
        video_id: currentVideo!.video_id, // fallback to empty string or handle properly
      };

      const response = await getQuizData(params);
      if (
        response?.detail === null ||
        response?.error === null ||
        response?.questions === null
      ) {
        currentVideo!.has_quiz = false;
      } else {
        dispatch(setQuizOverlayActive(true));
        Logger.info("Handling video end", quizOverlayActive);

        setQuizData(response);
      }
    } else {
      dispatch(setQuizOverlayActive(true));
      Logger.info("Handling video end", quizOverlayActive);
    }

    shouldTrackWatchTimeRef.current = false;

    // Always get fresh reference to current video
    // const currentVideo = videoStateRef.current;
    Logger.info("Video ended - has_quiz:", currentVideo?.has_quiz);

    // Handle quiz logic
    if (currentVideo?.has_quiz !== true) {
      dispatch(setNextVideo(true));
      return;
    }

    // Exit fullscreen first if needed
    const wasFullscreen = !!document.fullscreenElement;

    if (wasFullscreen) {
      try {
        await document.exitFullscreen();
      } catch (err) {
        Logger.warn("Could not exit fullscreen:", err);
      }
    }
    setShowQuiz(true); // Show quiz immediately
  }, [dispatch, quizOverlayActive]);

  useEffect(() => {
    // Exit fullscreen first if needed
    // Exit fullscreen if autoLogout is active
    if (autoLogoutActive === true) {
      try {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        Logger.info("Fullscreen closed due to auto-logout setting");
      } catch (err) {
        Logger.warn("Could not exit fullscreen:", err);
      }
    }
  }, [autoLogoutActive]);

  useEffect(() => {
    videoStateRef.current = selectedVideo;
  }, [selectedVideo]);
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  // -----------Video Quality Checking Method

  const getVideoQualities = async (player: any) => {
    try {
      if (
        player &&
        player.api &&
        typeof player.api.getVideoQualities === "function"
      ) {
        const qualityInfo = await player.api.getVideoQualities();
        Logger.info("Video qualities List:", qualityInfo);

        // Force low quality only for specific institute
        if (
          profileData.institute_id === "c979bfe5-a86f-4583-b3c5-c782e44cd2fd" &&
          qualityInfo.qualities.length > 0
        ) {
          const lowQualityIndex = 0; // index 0 = lowest quality
          if (typeof player.api.setVideoQuality === "function") {
            await player.api.setVideoQuality(lowQualityIndex);
            Logger.info("Low quality set for specific institute");
          } else {
            await tryAlternativeSETQualitySetting(lowQualityIndex);
          }
        }
      } else {
        await checkAlternativeGETQualityMethods(player);
      }
    } catch (error) {
      Logger.error("Error getting video qualities:", error);
    }
  };
  // Alternative method to check for quality options

  const checkAlternativeGETQualityMethods = async (player: any) => {
    try {
      // Try different possible method names
      const possibleMethods = [
        "getQualities",

        "getVideoQuality",

        "getAvailableQualityLevels",

        "qualityLevels",
      ];
      for (const method of possibleMethods) {
        if (typeof player.api[method] === "function") {
          const result = await player.api[method]();
          Logger.info(
            `Found alternative method  ${method}:for GetVideoQualities`,
            result,
          );
        }
      }
      if (player.api.qualities) {
        Logger.info(
          "Get Video qualities list using alternative method:",
          player.api.qualities,
        );
      }
    } catch (error) {
      Logger.error("Error checking alternative quality methods:", error);
    }
  };
  // Alternative quality setting methods

  const tryAlternativeSETQualitySetting = async (qualityId: number) => {
    const player = playerInstanceRef.current;
    if (!player) return;
    const alternativeMethods = [
      "setQuality",

      "setVideoQualityLevel",

      "setCurrentQuality",
    ];
    for (const method of alternativeMethods) {
      if (typeof player.api[method] === "function") {
        try {
          await player.api[method](qualityId);
          Logger.info(`Alternative Quality set using ${method}`);
          return;
        } catch (err) {
          Logger.error(
            `Video Quality TryAlternative Error with ${method}:`,
            err,
          );
        }
      }
    }
  };

  // Enhanced adaptive quality enable

  const handleEnableAdaptive = async () => {
    if (!playerInstanceRef.current) return;
    try {
      if (
        typeof playerInstanceRef.current.api.enableAdaptiveVideo === "function"
      ) {
        await playerInstanceRef.current.api.enableAdaptiveVideo();
        Logger.info("Adaptive quality enabled");
      } else {
        Logger.warn("enableAdaptiveVideo method not available");
      }
    } catch (error) {
      Logger.error("Error enabling adaptive quality:", error);
    }
  };
  // Modified setupPlayerEvents with stable handlers
  const setupPlayerEvents = useCallback(
    (player: any) => {
      // Logger.info("Setting up player events");

      // Set up new player instance
      playerInstanceRef.current = player;
      const handlers = {
        play: () => {
          // Logger.info("Video play event");
          setIsPlaying(true);
          shouldTrackWatchTimeRef.current = true;
          startTracking();
        },
        pause: () => {
          // Logger.info("Video pause event");
          setIsPlaying(false);
          shouldTrackWatchTimeRef.current = false;
          setIsIconVisible(true);
        },
        ended: handleVideoEnd,
        timeupdate: () => {
          if (playerInstanceRef.current) {
            const seconds = playerInstanceRef.current.video.currentTime;
            setCurrentTime(seconds);
            if (isUserSeekingRef.current) {
              updateWatchTime(seconds);
            }
          }
        },
        seeking: () => {
          // Logger.info("Video seeking");
          isUserSeekingRef.current = true;
        },
        seeked: () => {
          if (isUserSeekingRef.current) {
            // Logger.info("Video seeked");
            const roundedTime = Math.floor(currentTime);
            if (
              !isInitialSeekRef.current &&
              roundedTime !== lastTimeRef.current
            ) {
              postWatchTime(
                watchTimeRef.current *
                  playerInstanceRef.current.video.playbackRate,
                roundedTime,
              );
              watchTimeRef.current = 0;
            }
            lastTimeRef.current = roundedTime;
            isUserSeekingRef.current = false;
          }
        },

        loadedmetadata: () => {
          // Logger.info("Video metadata loaded");

          getVideoQualities(player);
        },
      };

      // Store handlers on player object for cleanup
      player._handlers = handlers;

      // Add event listeners
      player.video.addEventListener("play", handlers.play);
      player.video.addEventListener("pause", handlers.pause);
      player.video.addEventListener("ended", handlers.ended);
      player.video.addEventListener("timeupdate", handlers.timeupdate);
      player.video.addEventListener("seeking", handlers.seeking);
      player.video.addEventListener("seeked", handlers.seeked);
      //Video Quality

      player.video.addEventListener("loadedmetadata", handlers.loadedmetadata);
    },
    [currentTime, dispatch, selectedVideo?.has_quiz, handleVideoEnd],
  );

  // Modified cleanupPlayerEvents
  const cleanupPlayerEvents = useCallback((player: any) => {
    if (!player || !player._handlers) {
      // Logger.info("No player or handlers to clean up");
      return;
    }

    // Logger.info("Cleaning up player events");
    const { video, _handlers } = player;

    try {
      if (video && _handlers.play)
        video.removeEventListener("play", _handlers.play);
      if (video && _handlers.pause)
        video.removeEventListener("pause", _handlers.pause);
      if (video && _handlers.ended)
        video.removeEventListener("ended", _handlers.ended);
      if (video && _handlers.timeupdate)
        video.removeEventListener("timeupdate", _handlers.timeupdate);
      if (video && _handlers.seeking)
        video.removeEventListener("seeking", _handlers.seeking);
      if (video && _handlers.seeked)
        video.removeEventListener("seeked", _handlers.seeked);

      if (video && _handlers.loadedmetadata)
        video.removeEventListener("loadedmetadata", _handlers.loadedmetadata);
    } catch (error) {
      Logger.error("Error cleaning up player events:", error);
    } finally {
      delete player._handlers;
    }
  }, []);

  const initializePlayer = useCallback(() => {
    // Logger.info("Inside Init Player", !iframeRef.current);

    // if (!iframeRef.current) return;

    const checkAndSetupPlayer = () => {
      try {
        const player = window.VdoPlayer?.getInstance(iframeRef.current!);
        if (player?.api && player?.video) {
          setupPlayerEvents(player);
          setIframeLoading(false);

          // Set initial playback position if needed
          if (selectedVideo?.playback_position) {
            // player.api
            //   .seek(selectedVideo.playback_position)
            //   .catch(Logger.error);
            window.VdoPlayer?.seek(selectedVideo.playback_position);

            playerInstanceRef.current.currentTime =
              selectedVideo.playback_position;
          }

          return true;
        }
      } catch (err) {
        Logger.error("Player initialization error:", err);
        setIframeLoading(false);
      }
      return false;
    };

    // Try immediately
    if (checkAndSetupPlayer()) return;

    // Set up polling if not ready
    const initInterval = setInterval(() => {
      if (checkAndSetupPlayer()) {
        clearInterval(initInterval);
      }
    }, 200);

    return () => {
      clearInterval(initInterval);
      // Don't clean up player here - let the effect cleanup handle it
    };
  }, [
    selectedVideo?.playback_position,
    cleanupPlayerEvents,
    // setupPlayerEvents,
  ]);

  //Fixed useEffect for player initialization
  useEffect(() => {
    let script: HTMLScriptElement | null = null;
    let initInterval: NodeJS.Timeout;
    let isMounted = true;

    const initialize = () => {
      if (
        !isMounted ||
        !selectedVideo?.video_otp ||
        !selectedVideo?.playback_info
      )
        return;

      setIframeLoading(true);
      // Logger.info("Inside Init");
      if (!window.VdoPlayer) {
        script = document.createElement("script");
        script.src = "https://player.vdocipher.com/v2/api.js";
        script.async = true;
        script.setAttribute("allow", "autoplay; encrypted-media");

        script.onload = () => {
          if (!isMounted) return;
          initInterval = setInterval(() => {
            if (initializePlayer()) {
              // Logger.info("Inside Init onLoad");

              clearInterval(initInterval);
            }
          }, 200);
        };
        script.onerror = () => {
          if (!isMounted) return;
          Logger.error("Failed to load VdoCipher API");
          setIframeLoading(false);
        };
        document.body.appendChild(script);
      } else {
        // Logger.info("Inside Init Else");

        initializePlayer();
      }
    };

    initialize();

    return () => {
      isMounted = false;
      if (script && script.parentNode) {
        document.body.removeChild(script);
      }
      if (initInterval) clearInterval(initInterval);
      if (playerInstanceRef.current) {
        cleanupPlayerEvents(playerInstanceRef.current);
        playerInstanceRef.current = null;
      }
    };
  }, [selectedVideo, initializePlayer]);

  useEffect(() => {
    getFullVideo(state?.video_id!);
  }, [state?.video_id]);

  // Additionally, handle browser tab closing/refreshing
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (playerInstanceRef.current) {
        // Logger.info("Browser Refresh");
        cleanupPlayerEvents(playerInstanceRef.current);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [playerInstanceRef.current]);

  const stopTracking = useCallback(() => {
    // Logger.info("Stopping tracking");
    // if (intervalRef.current) {

    // }
    everySecondApiCall(); // Send final update
    clearInterval(intervalRef.current!);
    intervalRef.current = null;
  }, []);

  const everySecondApiCall = async () => {
    // Logger.info("PlayerInstance", playerInstanceRef.current);
    // Logger.info("PlayerInstance1", watchTimeVideoId.current);
    if (playerInstanceRef.current && watchTimeVideoId.current) {
      try {
        const currentTime = playerInstanceRef.current.video.currentTime;
        const playbackRate = playerInstanceRef.current.video.playbackRate;
        const totalWatchTime = watchTimeRef.current * playbackRate;

        // Logger.info("Sending watch time:", {
        //   time: Math.floor(currentTime),
        //   watchTime: totalWatchTime,
        // });

        await postWatchTime(totalWatchTime, Math.floor(currentTime));
        watchTimeRef.current = 0; // Reset after sending
      } catch (err) {
        Logger.error("Error in tracking API call:", err);
      }
    }
  };

  const updateWatchTime = (currentTime: number) => {
    const roundedTime = Math.floor(currentTime);
    if (
      isUserSeekingRef.current &&
      !isInitialSeekRef.current &&
      roundedTime !== lastTimeRef.current
    ) {
      postWatchTime(watchTimeRef.current, roundedTime);
      watchTimeRef.current = 0;
    }
    lastTimeRef.current = roundedTime;
  };
  // Update video ID ref when selected video changes
  useEffect(() => {
    watchTimeVideoId.current = selectedVideo?.video_id || null;
  }, [selectedVideo]);

  // Initialize seeking flag after first seek
  useEffect(() => {
    const timer = setTimeout(() => {
      isInitialSeekRef.current = false;
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // API functions
  const getFullVideo = async (videoId: string) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<FullVideoResponse>(
        VideoLandingPageClient.getVideoUrl,
        {
          course_id: state.course_id,
          topic_id: state.topic_id,
          video_id: videoId,
          program_id: state.program_id,
          program_category: state.program_category,
        },
      );
      setSelectedVideo(response.data);
      videoStateRef.current = response.data;
      updateIsNewFalse(videoId);
      setError(false);
      await getFullQuery(response.data.program_id, response.data.video_id);
    } catch (error) {
      Logger.error("Error fetching Videos:", error);
      setError(true);
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }
  };

  const getFullQuery = async (programId: string, videoId: string) => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    setSimmer(true);
    try {
      const response = await api
        .get<QueryResponse>(
          `${VideoLandingPageClient.getQuery}?program_id=${programId}&video_id=${videoId}`,
        )
        .then((response) => {
          const myQueries = response.data.my_queries.map((query) => ({
            ...query,
            isMyQuery: true,
          }));

          const otherQueries = response.data.other_queries.map((query) => ({
            ...query,
            isMyQuery: false,
          }));

          setQaList([...myQueries, ...otherQueries]);
        });
    } catch {
      Logger.error("Error fetching Videos:", error);
      setError(true);
    } finally {
      setSimmer(false);
    }
  };
  const postQuery = async (
    question: string,
  ): Promise<PostQueryResponse | null> => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Loader.showLoading();
    try {
      const response = await api
        .post<PostQueryResponse>(
          `${VideoLandingPageClient.getQuery}?video_id=${selectedVideo?.video_id}`,
          {
            query: { query: question },
            program_id: selectedVideo?.program_id,
            program_title: selectedVideo?.program_title,
            course_id: selectedVideo?.course_id,
            course_title: selectedVideo?.course_title,
            topic_id: selectedVideo?.topic_id,
            topic_title: selectedVideo?.topic_title,
            video_title: selectedVideo?.video_title,
            video_id: selectedVideo?.video_id,
          },
        )
        .then((response) => {
          handleShowNotification(response.data.detail);
          const newQuery: QueryItem & { isMyQuery: boolean } = {
            institute_id: state.institute_id,
            program_id: state.program_id,
            video_id: state.video_id,
            query: {
              query_id: `temp-${Date.now()}`,
              query: question,
              query_datetime: new Date().toISOString(),
            },
            response: {
              response_id: "",
              response: "",
              response_datetime: "",
            },
            status: "In Review",
            isMyQuery: true,
            //User Itself posting query
            first_name: userData.first_name,
            last_name: userData.last_name,
          };
          setQaList((prevQaList) => [newQuery, ...prevQaList]);
          return response.data;
        });
      return null;
    } catch (e) {
      Logger.error("Error submitting Query2:", error);
      return null;
    } finally {
      Loader.dismissLoading();
    }
  };

  const postWatchTime = async (watchTime: number, timeStamp: number) => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      await api
        .post<PostWatchTimeResponse>(
          `${VideoLandingPageClient.getVideoUrl}?program_id=${state.program_id}&program_category=${state.program_category}&course_id=${state.course_id}&topic_id=${state.topic_id}&video_id=${watchTimeVideoId.current}`,
          { timestamp: timeStamp, watch_time: watchTime },
        )
        .then((response) => {
          if (response.data.error !== null) {
            showAlert({
              identity: "",
              show: true,
              title: "Error",
              message: response.data.error,
              alertType: "error",
              onlyNeedOneButton: true,
              button1Text: "OK",
              btn1onPressed: () => {},
            });
          }
        });
    } catch (e) {
      Logger.error("Error submitting watch time:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const postContentWatchTime = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      await api
        .post<PostWatchTimeResponse>(
          `${VideoLandingPageClient.getVideoUrl}?program_id=${state.program_id}&program_category=${state.program_category}&course_id=${state.course_id}&topic_id=${state.topic_id}&video_id=${watchTimeVideoId.current}`,
          { content_type: "pdf", status: "Completed" },
        )
        .then((response) => {
          if (response.data.error !== null) {
            showAlert({
              identity: "",
              show: true,
              title: "Error",
              message: response.data.error,
              alertType: "error",
              onlyNeedOneButton: true,
              button1Text: "OK",
              btn1onPressed: () => {},
            });
          }
        });
    } catch (e) {
      Logger.error("Error submitting watch time:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  // UI handlers
  const handlePostQuestion = async () => {
    if (question.trim() === "") return;
    setCharCount(0);
    setQuestion("");
    await postQuery(question);
  };

  const updateIsNewFalse = (videoId: string) => {
    const updatedPlayingList = playingList.map((video) =>
      video.video_id === videoId ? { ...video, is_new: false } : video,
    );
    setPlayingList(updatedPlayingList);
  };
  // Add ref for PDF viewer
  const pdfViewerRef = useRef<PDFStreamViewerHandle>(null);
  // Update handleReplay
  useEffect(() => {
    const handleReplay = async (): Promise<void> => {
      if (!replay) return;

      try {
        // Logger.info("Replay triggered for:", selectedVideo?.content_type);

        // Exit fullscreen
        if (document.fullscreenElement) {
          await document.exitFullscreen();
        }

        // Reset UI
        setShowQuiz(false);
        setShowQuizComponent(false);
        setShowQuizGradedComponent(false);

        // Reset tracking
        shouldTrackWatchTimeRef.current = false;
        watchTimeRef.current = 0;
        isUserSeekingRef.current = false;
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        lastTimeRef.current = 0;
        isInitialSeekRef.current = false;

        // Content-specific replay
        if (selectedVideo?.content_type === "video") {
          // Video replay logic...
        } else if (selectedVideo?.content_type === "pdf") {
          // Reset PDF using ref
          if (pdfViewerRef.current) {
            pdfViewerRef.current.resetToFirstPage();
            // Logger.info("PDF reset to first page via ref");
          } else {
            // Fallback: Use key-based reset if ref not available
            // setPdfResetKey(prev => prev + 1);
          }
        }
      } catch (error) {
        Logger.error("Replay failed:", error);
      } finally {
        dispatch(setReplay(false));
      }
    };

    handleReplay();
  }, [replay, dispatch, selectedVideo]);

  // Add this useEffect to handle next video
  useEffect(() => {
    if (nextVideo) {
      Logger.info("Has Next Video");
      playNextVideo();
      dispatch(setNextVideo(false));
    }
  }, [nextVideo, dispatch]);
  useEffect(() => {
    if (selectedVideo && playingList) {
      const currentIndex = playingList.findIndex(
        (v) => v.video_id === selectedVideo?.video_id,
      );
      const hasNextVideo = currentIndex < playingList.length - 1;
      dispatch(setShowNextVideo(hasNextVideo));
    }
  }, [selectedVideo, playingList, dispatch]);
  const playNextVideo = async () => {
    Logger.info("Play next Video List", playingList);
    Logger.info("Play next Selected Video", selectedVideo);

    if (!playingList || !selectedVideo) return;

    const currentIndex = playingList.findIndex(
      (video) => video.video_id === selectedVideo?.video_id,
    );
    Logger.info("Play next Current Index", playerInstanceRef.current);
    if (currentIndex < playingList.length - 1) {
      const nextVideo = playingList[currentIndex + 1];
      if (selectedVideo.content_type === "pdf") {
        handleVideoSelect(nextVideo);
      } else {
        handleFileSelect(nextVideo);
      }
      Logger.info("We have next video");
    } else if (playerInstanceRef.current) {
      await playerInstanceRef.current.video.play();
      Logger.info("We are not having next video");
    }

    setShowQuiz(false);
    setShowQuizComponent(false);
    setShowQuizGradedComponent(false);

    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  };

  const handleMouseEnter = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setIsIconVisible(true);
    timerRef.current = setTimeout(() => {
      setIsIconVisible(false);
    }, 4000);
  };

  const handleShowNotification = (msg: string) => {
    setShowNotification(msg);
  };

  const handleCloseNotification = () => {
    setShowNotification(null);
  };

  const handleMouseMove = () => {
    if (!isIconVisible) {
      setIsIconVisible(true);
      timerRef.current = setTimeout(() => {
        setIsIconVisible(false);
      }, 4000);
    }
  };

  const handleMouseLeave = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    if (isPlaying) {
      setIsIconVisible(false);
    }
  };

  const toggleReadMore = (queryId: string) => {
    setExpandedQueries((prev: Record<string, boolean>) => ({
      ...prev,
      [queryId]: !prev[queryId],
    }));
  };

  const closeAssessmentCamera = () => {
    stopCamera();
    window.location.reload();
  };

  // Fullscreen handler
  useEffect(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
    };
  }, []);

  // Add these states to your VideoCypherPlayer component
  const [showMarkAsCompleted, setShowMarkAsCompleted] = useState(false);
  const [hasReachedPDFEnd, setHasReachedPDFEnd] = useState(false);
  const [pdfArtifactId, setPdfArtifactId] = useState<string | null>(null);
  const [totalPages, setTotalPages] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [showAlertForIsGraded, setShowAlertforIsGraded] = useState(false);
  const [showQuizGradedComponent, setShowQuizGradedComponent] = useState(false);

  // Modify handlePDFEnd to split the logic
  const handlePDFEnd = useCallback(
    async (artifactId: string, pageNumber: number) => {
      // Track that we've reached the end
      setHasReachedPDFEnd(true);
      setPdfArtifactId(artifactId);

      // Only post watch time immediately
      postContentWatchTime();
      const totalpages = pdfViewerRef.current?.getTotalPages();
      Logger.info("Total Pages:", totalPages);
      setTotalPages(totalpages!);
      const currentpages = pdfViewerRef.current?.getCurrentPage();
      Logger.info("Current page on End:", currentPage);
      setCurrentPage(currentpages!);
      // Show the "Mark as Completed" button
      setShowMarkAsCompleted(true);
    },
    [dispatch, quizOverlayActive],
  );
  const btnPressTriggers = () => {
    // Optionally focus on the quiz button
    setShowAlertforIsGraded(false);
    setShowMarkAsCompleted(true);
  };
  const handleSubmitTriggers = () => {
    setShowQuizGradedComponent(false); // for video graded
    setShowMarkAsCompleted(false); // for file content graded
  };
  const handleMarkAsCompleted = useCallback(async () => {
    if (!hasReachedPDFEnd || !pdfArtifactId) return;

    // Hide the button
    setShowMarkAsCompleted(false);

    // Now trigger the quiz logic
    dispatch(setQuizOverlayActive(true));

    const currentVideo = videoStateRef.current;
    if (currentVideo?.has_quiz === true) {
      const params = {
        program_id: state.program_id,
        course_id: state.course_id,
        topic_id: state.topic_id,
        video_id: currentVideo.video_id,
      };

      const response = await getQuizData(params);
      if (
        response?.detail === null ||
        response?.error === null ||
        response?.questions === null
      ) {
        currentVideo.has_quiz = false;
      } else {
        dispatch(setQuizOverlayActive(true));
        setQuizData(response);
      }
    } else {
      dispatch(setQuizOverlayActive(true));
    }

    // Handle quiz logic
    if (currentVideo?.has_quiz !== true) {
      dispatch(setNextVideo(true));
      return;
    }

    // Exit fullscreen if needed
    const wasFullscreen = !!document.fullscreenElement;
    if (wasFullscreen) {
      try {
        await document.exitFullscreen();
      } catch (err) {
        Logger.warn("Could not exit fullscreen:", err);
      }
    }

    // Show quiz
    setShowQuiz(true);

    // // Reset states
    // setHasReachedPDFEnd(false);
    setPdfArtifactId(null);
  }, [dispatch, quizOverlayActive, hasReachedPDFEnd, pdfArtifactId]);
  //Header Value showing
  const selectedProgramTitle = useSelector(
    (state: RootState) => state.dropdown.selectedProgram?.title,
  );
  const selectedTopicTitle = useSelector(
    (state: RootState) => state.learningRoom.selectedItem,
  );
  if (loading) {
    return (
      <div
        style={{
          height:
            LocalStorage.getLocalData("fromFlutter") !== "true"
              ? "90vh"
              : "100vh",
          backgroundColor: "#ffffff",
        }}
      >
        {(location.pathname === "/dashboard/learning-room/view-courses/video" ||
          location.pathname ===
            "/dashboard/learning-room/view-labsession/video") && (
          <LearningRoomViewHeader
            text={`${state?.selectedProgramTitle ?? selectedProgramTitle} > ${state?.course_name || selectedVideo?.course_title} > ${state?.labSession ? "" : (state?.selectedTopicTitle ?? selectedTopicTitle?.topic_title)}`}
            isVideoPage={true}
            onClick={() => {
              navigate("/dashboard/learning-room");
              dispatch(setQuizOverlayActive(false));
              dispatch(setQuizComponentActive(false));
            }}
          />
        )}
        {location.pathname.includes(
          "/dashboard/recommendation/jozunaview/video",
        ) && (
          <RecommendationViewHeader
            hours={selectedVideo?.video_duration_range ?? "0"}
            text={`${state.program_name} → ${state.course_name || selectedVideo?.course_title} → ${state.course_topic || ""}`}
            onClick={() => {
              Logger.info("Check ", hasReachedPDFEnd, totalPages, currentPage);

              // Check if all conditions are met
              if (
                selectedVideo?.is_graded === true &&
                selectedVideo?.has_quiz === true &&
                selectedVideo?.content_type === "pdf" &&
                // hasReachedPDFEnd === true &&
                // totalPages !== null &&
                // currentPage === totalPages
                showMarkAsCompleted === true
              ) {
                setShowAlertforIsGraded(true);
                return; // Don't navigate
              }

              if (
                selectedVideo?.is_graded === true &&
                selectedVideo?.has_quiz === true &&
                (showQuiz === true || showQuizGradedComponent === true)
              ) {
                setShowAlertforIsGraded(true);
                return; // Don't navigate
              }

              // If conditions not met, proceed with navigation
              if (state?.course_name !== null) {
                navigate(-1);
                dispatch(setQuizOverlayActive(false));
                dispatch(setQuizComponentActive(false));
              } else {
                navigate("/dashboard/learning-room/view-courses", {
                  state: {
                    video_id: state.video_id,
                    topic_id: state.topic_id,
                    course_name: selectedVideo?.course_title,
                    course_id: state.course_id,
                    program_id: state.program_id,
                  },
                });
                dispatch(setQuizOverlayActive(false));
                dispatch(setQuizComponentActive(false));
              }
            }}
          />
        )}
        {/* {location.pathname.includes(
          "/dashboard/recommendation/jozunaview/video",
        ) && <GreyHorizontalDivider />} */}

        {/* <GreyHorizontalDivider /> */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height:
              LocalStorage.getLocalData("fromFlutter") !== "true"
                ? "70vh"
                : "100vh",
          }}
        >
          Loading...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          height:
            LocalStorage.getLocalData("fromFlutter") !== "true"
              ? "90vh"
              : "100vh",
          backgroundColor: "#ffffff",
        }}
      >
        {(location.pathname === "/dashboard/learning-room/view-courses/video" ||
          location.pathname ===
            "/dashboard/learning-room/view-labsession/video") && (
          <LearningRoomViewHeader
            text={`${state?.selectedProgramTitle ?? selectedProgramTitle} > ${state?.course_name || selectedVideo?.course_title} > ${state?.labSession ? "" : (state?.selectedTopicTitle ?? selectedTopicTitle?.topic_title)}`}
            // text={`${selectedProgramTitle} > ${state?.course_name || selectedVideo?.course_title} > ${state?.labSession ? "" : selectedTopicTitle?.topic_title || ""}`}
            isVideoPage={true}
            onClick={() => {
              // navigate(-1);
              // dispatch(setQuizOverlayActive(false));
              // dispatch(setQuizComponentActive(false));
              Logger.info("Check ", state.course_name);
              if (state?.course_name !== null) {
                navigate(-1);
                dispatch(setQuizOverlayActive(false));
                dispatch(setQuizComponentActive(false));
              } else {
                navigate("/dashboard/learning-room/view-courses", {
                  state: {
                    video_id: state.video_id, // For initial video to play
                    topic_id: state.topic_id, // Videos topic id
                    course_name: selectedVideo?.course_title, // Course name
                    course_id: state.course_id, // Course ID
                    program_id: state.program_id,
                  },
                });
                dispatch(setQuizOverlayActive(false));
                dispatch(setQuizComponentActive(false));
              }
            }}
          />
        )}
        {location.pathname.includes(
          "/dashboard/recommendation/jozunaview/video",
        ) && (
          <RecommendationViewHeader
            hours={selectedVideo?.video_duration_range ?? "0"}
            text={`${state.program_name} → ${state.course_name || selectedVideo?.course_title} → ${state.course_topic || ""}`}
            onClick={() => {
              Logger.info("Check ", hasReachedPDFEnd, totalPages, currentPage);

              // Check if all conditions are met
              if (
                selectedVideo?.is_graded === true &&
                selectedVideo?.has_quiz === true &&
                selectedVideo?.content_type === "pdf" &&
                // hasReachedPDFEnd === true &&
                // totalPages !== null &&
                // currentPage === totalPages
                showMarkAsCompleted === true
              ) {
                setShowAlertforIsGraded(true);
                return; // Don't navigate
              }

              if (
                selectedVideo?.is_graded === true &&
                selectedVideo?.has_quiz === true &&
                (showQuiz === true || showQuizGradedComponent === true)
              ) {
                setShowAlertforIsGraded(true);
                return; // Don't navigate
              }

              // If conditions not met, proceed with navigation
              if (state?.course_name !== null) {
                navigate(-1);
                dispatch(setQuizOverlayActive(false));
                dispatch(setQuizComponentActive(false));
              } else {
                navigate("/dashboard/learning-room/view-courses", {
                  state: {
                    video_id: state.video_id,
                    topic_id: state.topic_id,
                    course_name: selectedVideo?.course_title,
                    course_id: state.course_id,
                    program_id: state.program_id,
                  },
                });
                dispatch(setQuizOverlayActive(false));
                dispatch(setQuizComponentActive(false));
              }
            }}
          />
        )}
        {/* {location.pathname.includes(
          "/dashboard/recommendation/jozunaview/video",
        ) && <GreyHorizontalDivider />} */}
        <h4 style={{ paddingLeft: "25px", paddingTop: "20px" }}>
          {state?.course_topic!}
        </h4>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height:
              LocalStorage.getLocalData("fromFlutter") !== "true"
                ? "70vh"
                : "100vh",
          }}
        >
          Something Went Wrong. Try Again Later...
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        // height:
        //   LocalStorage.getLocalData("fromFlutter") !== "true"
        //     ? "100vh"
        //     : "100vh",
        backgroundColor: "#ffffff",
        // overflow: "auto",
      }}
    >
      {(location.pathname === "/dashboard/learning-room/view-courses/video" ||
        location.pathname ===
          "/dashboard/learning-room/view-labsession/video") && (
        <LearningRoomViewHeader
          text={`${state?.selectedProgramTitle ?? selectedProgramTitle} > ${state?.course_name || selectedVideo?.course_title} ${state?.labSession ? "" : ">"} ${state?.labSession ? "" : (state?.selectedTopicTitle ?? selectedTopicTitle?.topic_title)}`}
          // text={`${selectedProgramTitle} > ${state?.course_name || selectedVideo?.course_title} > ${state?.labSession ? "" : selectedTopicTitle?.topic_title || ""}`}
          isVideoPage={true}
          onClick={() => {
            Logger.info("Check ", hasReachedPDFEnd, totalPages, currentPage);

            // Check if all conditions are met
            if (
              selectedVideo?.is_graded === true &&
              selectedVideo?.has_quiz === true &&
              selectedVideo?.content_type === "pdf" &&
              // hasReachedPDFEnd === true &&
              // totalPages !== null &&
              // currentPage === totalPages
              showMarkAsCompleted === true
            ) {
              setShowAlertforIsGraded(true);
              return; // Don't navigate
            }

            if (
              selectedVideo?.is_graded === true &&
              selectedVideo?.has_quiz === true &&
              (showQuiz === true || showQuizGradedComponent === true)
            ) {
              setShowAlertforIsGraded(true);
              return; // Don't navigate
            }

            // If conditions not met, proceed with navigation
            // if (state?.course_name !== null) {
            navigate(-1);
            dispatch(setQuizOverlayActive(false));
            dispatch(setQuizComponentActive(false));
            // } else {
            // navigate("/dashboard/learning-room", {
            //   state: {
            //     video_id: state.video_id,
            //     topic_id: state.topic_id,
            //     course_name: selectedVideo?.course_title,
            //     course_id: state.course_id,
            //     program_id: state.program_id,
            //   },
            // });
            // dispatch(setQuizOverlayActive(false));
            // dispatch(setQuizComponentActive(false));
            // }
          }}
        />
      )}
      {location.pathname.includes(
        "/dashboard/recommendation/jozunaview/video",
      ) && (
        <RecommendationViewHeader
          hours={selectedVideo?.video_duration_range ?? "0"}
          text={`${state.program_name} → ${state.course_name || selectedVideo?.course_title} → ${state.course_topic || ""}`}
          onClick={() => {
            Logger.info("Check ", hasReachedPDFEnd, totalPages, currentPage);

            // Check if all conditions are met
            if (
              selectedVideo?.is_graded === true &&
              selectedVideo?.has_quiz === true &&
              selectedVideo?.content_type === "pdf" &&
              // hasReachedPDFEnd === true &&
              // totalPages !== null &&
              // currentPage === totalPages
              showMarkAsCompleted === true
            ) {
              setShowAlertforIsGraded(true);
              return; // Don't navigate
            }

            if (
              selectedVideo?.is_graded === true &&
              selectedVideo?.has_quiz === true &&
              (showQuiz === true || showQuizGradedComponent === true)
            ) {
              setShowAlertforIsGraded(true);
              return; // Don't navigate
            }

            // If conditions not met, proceed with navigation
            if (state?.course_name !== null) {
              navigate(-1);
              dispatch(setQuizOverlayActive(false));
              dispatch(setQuizComponentActive(false));
            } else {
              navigate("/dashboard/learning-room/view-courses", {
                state: {
                  video_id: state.video_id,
                  topic_id: state.topic_id,
                  course_name: selectedVideo?.course_title,
                  course_id: state.course_id,
                  program_id: state.program_id,
                },
              });
              dispatch(setQuizOverlayActive(false));
              dispatch(setQuizComponentActive(false));
            }
          }}
        />
      )}
      {/* {location.pathname.includes(
        "/dashboard/recommendation/jozunaview/video",
      ) && <GreyHorizontalDivider />} */}

      <div
        className="video-container-page"
        style={{ height: "90vh", overflowY: "auto", overflowX: "hidden" }}
      >
        {" "}
        <div className="video-players">
          <div className="videoplay-titlediv">
            <div className="video-info" style={{ width: "100%" }}>
              <div className="video-info-header">
                <div
                  className="video-tag"
                  style={{ gap: "10px", alignItems: "center" }}
                >
                  {state.labSession ? (
                    <span className="video-label lab-session">Lab session</span>
                  ) : (
                    <span className="video-label content-video">
                      {selectedVideo?.content_type === "video"
                        ? "Content Video"
                        : "Content File"}
                    </span>
                  )}
                  <span
                    className="videoplay-titlediv-copyrightstext"
                    onClick={() => setCopyRightPopUp(true)}
                  >
                    ⚠️ Copyright Notice
                  </span>
                </div>
                <p className="video-posted-date">
                  Posted on{" "}
                  {CommonUtils.formatAllRegionDate(
                    selectedVideo?.video_posted_on ?? "",
                  )}
                </p>
              </div>
              <p
                style={{
                  fontSize: "22px",
                  fontFamily: "Mazzard",
                  fontWeight: 700,
                }}
              >
                {" "}
                {selectedVideo?.content_type === "video"
                  ? selectedVideo?.video_title
                  : selectedVideo?.file_title}
              </p>
              <p
                style={{
                  fontSize: "19px",
                  fontFamily: "Mazzard",
                  fontWeight: "500",
                }}
              >
                <AutoLinkText
                  text={
                    selectedVideo?.content_type === "video"
                      ? selectedVideo?.video_description
                      : selectedVideo?.file_description!
                  }
                />{" "}
              </p>
            </div>
          </div>
          <div
            ref={videoContainerRef}
            style={{
              position: "relative",
              width: "100%",
              height: "auto",
              aspectRatio: "16/9",
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseMove={handleMouseMove}
          >
            {selectedVideo?.content_type === "video" && (
              <iframe
                ref={iframeRef}
                src={buildPlayerUrl()}
                // src="https://player.vdocipher.com/v2/?otp=20160313versASE3232uoGGPMtbJI0ioXKG8pf9QI501kj0KJ17qvYrMNWvjYs1V&playbackInfo=eyJ2aWRlb0lkIjoiOGQ3MTM4M2RmNTY3NGJkYmIxZjA1NTMyM2E1ZjNlZjEifQ=="
                title="VdoCipher Player"
                allow="encrypted-media"
                // allow="autoplay; fullscreen"
                allowFullScreen
                frameBorder="0"
                style={{
                  width: "100%",
                  height: "100%",
                }}
                onLoadedMetadata={() => {
                  if (
                    playerInstanceRef.current &&
                    selectedVideo?.playback_position
                  ) {
                    playerInstanceRef.current.currentTime =
                      selectedVideo.playback_position;
                  }
                  setTimeout(() => {
                    isInitialSeekRef.current = false;
                  }, 2000);
                }}
              />
            )}
            {/* {selectedVideo?.content_type !== "video" && (
              <PDFStreamViewer
                ref={pdfViewerRef}
                // key={`pdf-${selectedVideo?.video_id}-reset${pdfResetKey}`}
                showDownload={selectedVideo?.is_downloadable}
                artifact_Id={selectedVideo?.video_id}
                onReachEnd={handlePDFEnd}
                autoLoad={true}
              ></PDFStreamViewer>
            )} */}
            {selectedVideo?.content_type &&
              selectedVideo?.content_type === "pdf" && (
                <PDFStreamViewer
                  ref={pdfViewerRef}
                  showDownload={selectedVideo?.is_downloadable}
                  artifact_Id={selectedVideo?.video_id}
                  onReachEnd={handlePDFEnd}
                  autoLoad={true}
                >
                  {/* Conditionally render the button inside PDF viewer */}
                  {showMarkAsCompleted &&
                    selectedVideo?.content_type === "pdf" &&
                    selectedVideo.has_quiz === true && (
                      <button
                        onClick={handleMarkAsCompleted}
                        style={{
                          backgroundColor: "#ffc85d",
                          fontFamily: "Mazzard",
                          fontSize: "14px",
                          color: "#000",
                          borderRadius: "6px",
                          height: "40px",
                          border: "none",
                          padding: "0 20px",
                          cursor: "pointer",
                          fontWeight: "600",
                          minWidth: "150px",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#ffd27a")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "#ffc85d")
                        }
                      >
                        Start Pop Quiz
                      </button>
                    )}
                </PDFStreamViewer>
              )}
            {showWaterMark && (
              <div
                className="watermark1"
                style={{
                  position: "absolute",
                  top: position.top,
                  left: position.left,
                }}
              >
                {LocalStorage.getLocalData("email_address")} @
                {timestamp.toLocaleTimeString("en-US", {
                  hour12: false,
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
                @{timestamp.getFullYear()}
              </div>
            )}
            {copyRightPopUp && (
              <div className="quizOverlay-noactiveBackground">
                <CopyRightPopup
                  title={"⚠️ Copyright Notice"}
                  body={
                    "This content is for educational use only. Unauthorized recording, redistribution, or commercial use may violate copyright laws and platform policies. Please respect content ownership and usage guidelines."
                  }
                  btn1onPressed={() => {
                    setCopyRightPopUp(false);
                  }}
                ></CopyRightPopup>
              </div>
            )}
            <div className="quizOverlayid">
              {selectedVideo?.has_quiz !== false && showQuiz && (
                // && state.course_name === "Database"
                <div className="quizOverlay">
                  {quizComponentActive && (
                    <QuizPopUpLogout
                      title={"Logout"}
                      body={"Are you sure you want to logout?"}
                      btn1onPressed={() => {
                        Logger.info("ok clicked");
                        if (document.fullscreenElement) {
                          document.exitFullscreen();
                        }
                        dispatch(setQuizComponentActive(false));
                        dispatch(setQuizOverlayActive(false));
                        logoutUser(
                          dispatch,
                          navigate,
                          userData.candidate_id || "",
                          api,
                          closeAssessmentCamera,
                        );
                      }}
                      btn2onPressed={() => {
                        dispatch(setQuizComponentActive(false));
                        // setShowQuizComponent(true);
                      }}
                    ></QuizPopUpLogout>
                  )}
                  {showAlertForIsGraded && (
                    <QuizPopUpLogout
                      title={"Warning"}
                      body={
                        "Completing the pop-quiz is mandatory. Please complete the pop-quiz before proceeding"
                      }
                      btn1onPressed={() => {
                        // Optionally focus on the quiz button
                        setShowAlertforIsGraded(false);
                        setShowMarkAsCompleted(true);
                      }}
                      btn2onPressed={() => {
                        // Optionally focus on the quiz button
                        setShowAlertforIsGraded(false);
                        setShowMarkAsCompleted(true);
                      }}
                    ></QuizPopUpLogout>
                  )}
                  {popshowAlert && (
                    <QuizPopUp
                      title={"Confirmation"}
                      body={"Are you sure you want to skip the quiz?"}
                      btn1onPressed={async () => {
                        Logger.info("Skip Quiz button clicked");

                        // Exit fullscreen if active
                        if (document.fullscreenElement) {
                          try {
                            await document.exitFullscreen();
                          } catch (err) {
                            Logger.warn("Could not exit fullscreen:", err);
                          }
                        }

                        // Dispatch action to play next video
                        dispatch(setNextVideo(true));

                        // Close quiz components
                        setShowQuizComponent(false);
                        setShowQuizGradedComponent(false);
                        setShowQuiz(false);
                        setpopShowAlert(false);

                        // Reset all tracking states (same as handleVideoSelect)
                        shouldTrackWatchTimeRef.current = false;
                        watchTimeRef.current = 0;
                        isUserSeekingRef.current = false;

                        // Clear tracking interval
                        if (intervalRef.current) {
                          clearInterval(intervalRef.current);
                          intervalRef.current = null;
                        }

                        lastTimeRef.current = 0;
                        isInitialSeekRef.current = false;

                        Logger.info(
                          "After skip quiz - iframe ref:",
                          iframeRef.current,
                        );

                        // IMPORTANT: Only reinitialize player if we have a video content type
                        // Check if the current content is video
                        if (
                          selectedVideo?.content_type === "video" &&
                          iframeRef.current
                        ) {
                          Logger.info(
                            "Reinitializing player for video content",
                          );

                          // Wait a bit for cleanup
                          await new Promise((resolve) =>
                            setTimeout(resolve, 100),
                          );

                          try {
                            // Get player instance with safety checks
                            const player = window.VdoPlayer?.getInstance(
                              iframeRef.current!,
                            );

                            if (player && player.video && player.api) {
                              Logger.info(
                                "Player found, reinitializing events",
                              );

                              // Clean up any existing event listeners
                              if (playerInstanceRef.current) {
                                try {
                                  cleanupPlayerEvents(
                                    playerInstanceRef.current,
                                  );
                                } catch (cleanupError) {
                                  Logger.warn(
                                    "Error during cleanup:",
                                    cleanupError,
                                  );
                                }
                              }

                              // Set up new player instance
                              playerInstanceRef.current = player;
                              setupPlayerEvents(player);

                              // Optionally reset playback position to beginning
                              try {
                                await player.api.seek(0);
                                // If you want to auto-play after skipping quiz:
                                // await player.api.play();
                              } catch (seekError) {
                                Logger.warn(
                                  "Could not reset playback position:",
                                  seekError,
                                );
                              }
                            } else {
                              Logger.warn(
                                "Player instance not available, will try to reinitialize iframe",
                              );

                              // Fallback: Reset iframe source to force reinitialization
                              if (selectedVideo) {
                                iframeRef.current.src = "";
                                await new Promise((resolve) =>
                                  setTimeout(resolve, 50),
                                );
                                iframeRef.current.src =
                                  buildPlayerUrl(selectedVideo);

                                // Wait for player to load
                                await new Promise((resolve) =>
                                  setTimeout(resolve, 500),
                                );

                                // Try to get player again
                                const retryPlayer =
                                  window.VdoPlayer?.getInstance(
                                    iframeRef.current!,
                                  );
                                if (retryPlayer) {
                                  playerInstanceRef.current = retryPlayer;
                                  setupPlayerEvents(retryPlayer);
                                  Logger.info(
                                    "Player reinitialized after iframe reset",
                                  );
                                }
                              }
                            }
                          } catch (playerError) {
                            Logger.error(
                              "Error reinitializing player after skip quiz:",
                              playerError,
                            );

                            // // Show error to user but don't block navigation
                            // showAlert({
                            //   identity: "default",
                            //   title: "Player Reset",
                            //   message:
                            //     "Video player may need manual refresh to continue.",
                            //   alertType: "error",
                            //   onlyNeedOneButton: true,
                            //   button1Text: "OK",
                            //   btn1onPressed: () => {},
                            // });
                          }
                        } else {
                          // For PDF content or no iframe, just log
                          Logger.info(
                            "No player reinitialization needed (PDF content or no iframe)",
                          );
                        }
                      }}
                      btn2onPressed={() => {
                        setpopShowAlert(false);
                        // setShowQuizComponent(true);
                      }}
                    ></QuizPopUp>
                  )}

                  {selectedVideo?.is_graded === true &&
                  selectedVideo?.has_quiz === true ? (
                    <></>
                  ) : (
                    <span
                      className="skipQuiz"
                      onClick={() => {
                        setpopShowAlert(true);
                      }}
                    >
                      Skip Quiz
                    </span>
                  )}

                  {/* <h3>Quick Quiz Landing Page</h3> */}
                  <h1 className="quizReadyText">Ready for a</h1>
                  <img src={quizText} alt="quizText" className="quizText" />
                  <br />

                  <p className="quizReadyText2">
                    Test your understanding of the concepts from the video
                  </p>
                  <br />
                  <button
                    onClick={async () => {
                      // const params = {
                      //   program_id: state.program_id,
                      //   course_id: state.course_id,
                      //   topic_id: state.topic_id,
                      //   video_id: selectedVideo?.video_id || "", // fallback to empty string or handle properly
                      // };

                      // const response = await getQuizData(params);
                      // setQuizData(response);
                      setShowQuizComponent(true);
                      setShowQuizGradedComponent(true);
                      setShowQuiz(false);

                      setTimeout(() => {
                        const quizContainer = document.getElementById(
                          "quizFullscreenContainer",
                        );
                        if (quizContainer?.requestFullscreen) {
                          quizContainer.requestFullscreen();
                        } else if (quizContainer?.requestFullscreen) {
                          quizContainer.requestFullscreen(); // Safari
                        } else if (quizContainer?.requestFullscreen) {
                          quizContainer.requestFullscreen(); // IE11
                        }
                      }, 100);
                    }}
                    className="quizButton"
                  >
                    Take me to the Quiz
                  </button>
                </div>
              )}

              {showQuizComponent ? (
                quizData &&
                Array.isArray(quizData.questions) &&
                quizData.questions.length > 0 ? (
                  <div>
                    <QuizComponent
                      setShowQuizComponent={setShowQuizComponent}
                      quizData={quizData}
                      video_id={selectedVideo?.video_id || ""}
                      assessment_id={quizData.assessment_id ?? ""}
                      is_graded={selectedVideo?.is_graded!}
                      showAlertForIsGraded={showAlertForIsGraded}
                      btnPressTriggers={btnPressTriggers}
                      handleSubmitTriggers={handleSubmitTriggers}
                    />
                  </div>
                ) : (
                  <div className="popquiz-container">
                    {showAlertForNoQuiz && (
                      <QuizPopUpLogout
                        title={"Confirmation"}
                        body={"Are you sure you want to skip the quiz?"}
                        btn1onPressed={() => {
                          if (document.fullscreenElement) {
                            document.exitFullscreen();
                          }
                          dispatch(setNextVideo(true));
                          setShowQuizComponent(false); // hide the quiz
                          setShowQuizGradedComponent(false);
                        }}
                        btn2onPressed={() => {
                          setShowAlert(false);
                        }}
                      ></QuizPopUpLogout>
                    )}
                    <div
                      className="popquiz-header"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <img src={QuizImg} alt="quiz" className="popQuizImg" />
                      <button
                        className="skip-popquiz"
                        onClick={() => {
                          setShowAlert(true);
                        }}
                      >
                        Skip Quiz
                      </button>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        color: "white",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      <p
                        style={{
                          color: "white",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        Can't able to start the quiz.{" "}
                      </p>
                    </div>
                  </div>
                )
              ) : null}
            </div>
          </div>
          <div className="video-info">
            {selectedVideo?.video_artifacts && (
              <div className="tab-content">
                <div>
                  Resources
                  <Tooltip
                    title="This is a compressed (.zip) file. To access the contents, you'll need to extract it. Right-click the downloaded file and choose 'Extract All…' (Windows) or simply double-click it (Mac)."
                    placement="top"
                    arrow
                  >
                    <img
                      src={infoImage}
                      alt="info"
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                    />
                  </Tooltip>
                </div>
                <div className="resource-card">
                  <div className="card-header">
                    <h4 style={{ fontFamily: "Mazzard", color: "#2D2D2D" }}>
                      {/* Supporting Artifact */}
                      {selectedVideo?.artifact_name}
                    </h4>
                    {/* <p style={{ fontFamily: "Mazzard", color: "#717579" }}>
                      This is placeholder value to write notes on the download
                    </p> */}
                  </div>
                  <a
                    href={selectedVideo?.video_artifacts}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button
                      className="Downloadbutton"
                      disabled={selectedVideo?.video_artifacts === null}
                    >
                      <img
                        src={downloadArrow}
                        alt="Download"
                        className="download-icon"
                      />{" "}
                      Download
                    </button>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
        {/*Q & A Section}*/}
        <div
          className="QA-Sessions-tab"
          style={{
            width: "30%",
            backgroundColor: "#E7efff",
            padding: "15px",
            borderRadius: "8px",
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div className="QA-header">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "5px",
              }}
            >
              <label className="QA-label">Discussion Board</label>
              {/* Refresh Icon with Tooltip */}
              <Tooltip title="Refresh" arrow placement="top">
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginLeft: "8px",
                    cursor: "pointer",
                    color: "#333",
                  }}
                  onClick={() => {
                    getFullQuery(
                      selectedVideo?.program_id,
                      selectedVideo?.video_id!,
                    );
                  }}
                >
                  <div style={{ marginTop: "-10px" }}>
                    <FaRedo size={15} color="#242730" />
                  </div>
                </span>
              </Tooltip>
            </div>
          </div>
          <div>
            <div
              className="QA-list"
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {simmer
                ? // Shimmer effect while loading
                  [...Array(3)].map((_, index) => (
                    <div key={index} className="QA-container shimmer"></div>
                  ))
                : // Render actual queries and responses
                  qaList.map((qa) => (
                    <div key={qa.query.query_id} className="QA-container">
                      <div className="QA-item-wrapper">
                        <div className="QA-question-icon">
                          {qa.first_name?.charAt(0) || "Q"}
                        </div>
                        <div
                          className={`QA-item ${
                            qa.status === "In Review" ? "in-review-bg" : ""
                          }`}
                          style={{
                            height:
                              expandedQueries[qa.query.query_id] ||
                              expandedQueries[qa.response.response_id]
                                ? "auto"
                                : "40px",
                            minHeight:
                              qa.query.query.length > MAX_LENGTH
                                ? "90px"
                                : qa.response?.response &&
                                    qa.response?.response.length > MAX_LENGTH
                                  ? "25vh"
                                  : qa.response?.response
                                    ? "16vh"
                                    : "44px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <p className="QA-question-text">
                              {qa.query.query.length > MAX_LENGTH ? (
                                expandedQueries[qa.query.query_id] ? (
                                  <>
                                    {qa.query.query}
                                    <span
                                      className="read-less-btn"
                                      onClick={() =>
                                        toggleReadMore(qa.query.query_id)
                                      }
                                    >
                                      {" "}
                                      Read Less
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    {qa.query.query.substring(0, MAX_LENGTH)}
                                    <span
                                      className="read-more-btn"
                                      onClick={() =>
                                        toggleReadMore(qa.query.query_id)
                                      }
                                    >
                                      ...Read More
                                    </span>
                                  </>
                                )
                              ) : (
                                qa.query.query
                              )}
                            </p>

                            {/* Status Badge & Tooltip */}
                            {qa.isMyQuery && !qa.response?.response && (
                              <div className="status-container">
                                {/* <div
                                className={`status-badge ${qa.status.replace(
                                  " ",
                                  "_",
                                )}`}
                              >
                                {qa.status.replace("_", " ")}
                              </div> */}
                                <img
                                  className={
                                    qa.status === "In Review"
                                      ? "status-icon-inreview"
                                      : "status-icon"
                                  }
                                  src={
                                    qa.status === "In Review"
                                      ? inReviewImg
                                      : qa.status === "Approved"
                                        ? approveImg
                                        : rejectImg
                                  }
                                />
                                {qa.status === "Approved" ? (
                                  <Tooltip
                                    title="The query is approved and posted in public. The comment will appear below the video once the admin replies."
                                    placement="top"
                                    arrow
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "#333",
                                          color: "#fff",
                                          fontSize: "12px",
                                          padding: "8px",
                                          borderRadius: "6px",
                                        },
                                      },
                                      arrow: { sx: { color: "#333" } },
                                    }}
                                  >
                                    <img
                                      src={infoApprove}
                                      alt="approved-icon"
                                      className="status-icon"
                                    />
                                  </Tooltip>
                                ) : qa.status === "In Review" ? (
                                  <Tooltip
                                    title="The comment will appear below the video in 2-3 business days once the admin approves it."
                                    placement="top"
                                    arrow
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "#333",
                                          color: "#fff",
                                          fontSize: "12px",
                                          padding: "8px",
                                          borderRadius: "6px",
                                        },
                                      },
                                      arrow: { sx: { color: "#333" } },
                                    }}
                                  >
                                    <img
                                      src={infoReview}
                                      alt="in-review-icon"
                                      className="status-icon"
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    title={
                                      <div style={{ textAlign: "left" }}>
                                        <div>Reason for Rejection:</div> <br />
                                        The comment violates our content policy
                                        rules.
                                      </div>
                                    }
                                    placement="top"
                                    arrow
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "#333",
                                          color: "#fff",
                                          fontSize: "12px",
                                          padding: "8px",
                                          borderRadius: "6px",
                                        },
                                      },
                                      arrow: { sx: { color: "#333" } },
                                    }}
                                  >
                                    <img
                                      src={infoReject}
                                      alt="rejected-icon"
                                      className="status-icon"
                                    />
                                  </Tooltip>
                                )}
                              </div>
                            )}
                          </div>
                          {/* Response Section */}
                          {qa.response?.response && (
                            <div
                              className="QA-answer-wrapper"
                              style={{
                                height: expandedQueries[qa.response.response_id]
                                  ? "auto"
                                  : "40px",
                              }}
                            >
                              {/* //   <img
                            //     src={jozunaIcon}
                            //     alt="answer-icon"
                            //     className="QA-answer-icon"
                            //   /> */}
                              <div className="QA-answerItem">
                                <p className="QA-answer-text">
                                  {qa.response?.response.length > MAX_LENGTH ? (
                                    expandedQueries[
                                      qa.response?.response_id
                                    ] ? (
                                      <>
                                        {qa.response?.response}
                                        <span
                                          className="read-less-btn"
                                          onClick={() =>
                                            toggleReadMore(
                                              qa.response?.response_id,
                                            )
                                          }
                                        >
                                          {" "}
                                          Read Less
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        {qa.response?.response.substring(
                                          0,
                                          MAX_LENGTH,
                                        )}
                                        <span
                                          className="read-more-btn"
                                          onClick={() =>
                                            toggleReadMore(
                                              qa.response?.response_id,
                                            )
                                          }
                                        >
                                          ...Read More
                                        </span>
                                      </>
                                    )
                                  ) : (
                                    qa.response?.response
                                  )}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
                alignItems: "flex-end",
                gap: "8px",
              }}
            >
              <p className="character-counts">
                {charCount}/{maxChars} Characters
              </p>
              <div className="QA-input-container">
                <textarea
                  ref={textareaRef}
                  className="QA-session-field"
                  placeholder="Leave your question here"
                  maxLength={500}
                  value={question}
                  onChange={(e) => {
                    setQuestion(e.target.value);
                    setCharCount(e.target.value.length);
                  }}
                  style={{
                    resize: "none",
                    paddingTop: question.trim() === "" ? "12px" : "11px",
                    paddingLeft: question.trim() === "" ? "10px" : "11px",
                    paddingBottom: question.trim() === "" ? "" : "10px",
                    paddingRight: question.trim() === "" ? "" : "10px",

                    overflow: "hidden",
                    lineHeight: "1",
                    fontSize: "14px",
                    fontFamily: "Mazzard",
                  }}
                />
                <button
                  className="QA-post"
                  disabled={question.trim() === ""}
                  style={{
                    backgroundColor:
                      question.trim() === "" ? "grey" : "#FFA800",
                    cursor: question.trim() === "" ? "default" : "pointer",
                    color: question.trim() === "" ? "white" : "black",
                    fontWeight: "600",
                  }}
                  onClick={handlePostQuestion}
                >
                  <img src={querySend} style={{ width: "20px" }} />
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="video-list">
          {state?.video_list?.map((video: FullVideoResponse) => {
            const index = state.video_list.findIndex(
              (v: FullVideoResponse) => v.video_id === video.video_id,
            );
            return (
              <div
                key={video.video_id}
                className={`video-item-page ${
                  video.video_id === selectedVideo?.video_id ? "active" : ""
                }`}
                onClick={() => {
                  // handleVideoSelect(video);
                  dispatch(setQuizOverlayActive(false));
                  dispatch(setQuizComponentActive(false));
                  // getFullQuery(state.program_id, video.video_id);
                }}
              >
                <OverlayComponent
                  videoUrl={
                    video.content_type === "video"
                      ? video.video_thumbnail
                      : PDFIcon
                  }
                  isSelected={video.video_id === selectedVideo?.video_id}
                  isNew={playingList[index]?.is_new}
                  width="200px"
                  height="112px"
                  playBtnWidth="40px"
                  playBtnHeight="30px"
                  videoTitle={video.video_title}
                  videoorcontenttext={
                    video.content_type === "video"
                      ? "Currently Playing"
                      : "Currently Viewing"
                  }
                  onClick={() => {
                    // Check if all conditions are met
                    Logger.info(
                      "Video/File clicked:",
                      selectedVideo?.is_graded,
                      selectedVideo?.has_quiz,
                      selectedVideo?.content_type,
                      showMarkAsCompleted,
                      showQuiz,
                      showQuizGradedComponent,
                    );
                    if (
                      selectedVideo?.is_graded === true &&
                      selectedVideo?.has_quiz === true &&
                      selectedVideo?.content_type === "pdf" &&
                      // hasReachedPDFEnd === true &&
                      // totalPages !== null &&
                      // currentPage === totalPages
                      showMarkAsCompleted === true
                    ) {
                      Logger.info("Video/File clicked: if");
                      setShowAlertforIsGraded(true);
                    } else {
                      if (
                        selectedVideo?.is_graded === true &&
                        selectedVideo?.has_quiz === true &&
                        (showQuiz === true || showQuizGradedComponent === true)
                      ) {
                        Logger.info("Video/File clicked: else if");
                        setShowAlertforIsGraded(true);
                      } else {
                        Logger.info("Video/File clicked: else");
                        if (video.content_type === "video") {
                          Logger.info("Video clicked:");
                          handleVideoSelect(video);
                        }
                        if (video.content_type === "pdf") {
                          Logger.info("file clicked:");
                          handleFileSelect(video);
                        }
                      }
                      // getFullQuery(state.program_id, video.video_id);F
                    }
                  }}
                />
                <h4 style={{ paddingTop: "5px" }}>
                  {video.content_type === "video"
                    ? video.video_title
                    : video.file_title}
                </h4>
              </div>
            );
          })}
        </div> */}
      </div>
      {quizComponentActive && (
        <QuizPopUpLogout
          title={"Logout"}
          body={"Are you sure you want to logout?"}
          btn1onPressed={() => {
            Logger.info("ok clicked");
            if (document.fullscreenElement) {
              document.exitFullscreen();
            }
            dispatch(setQuizComponentActive(false));
            dispatch(setQuizOverlayActive(false));
            logoutUser(
              dispatch,
              navigate,
              userData.candidate_id || "",
              api,
              closeAssessmentCamera,
            );
          }}
          btn2onPressed={() => {
            dispatch(setQuizComponentActive(false));
            // setShowQuizComponent(true);
          }}
        ></QuizPopUpLogout>
      )}
      {showNotification && (
        <SuccessInfoPopup
          message={showNotification}
          onClose={handleCloseNotification}
        />
      )}
      {showAlertForIsGraded && (
        <QuizPopUpLogout
          title={"Warning"}
          body={
            "Completing the pop-quiz is mandatory. Please complete the pop-quiz before proceeding"
          }
          btn1onPressed={() => {
            // Optionally focus on the quiz button
            setShowAlertforIsGraded(false);
            setShowMarkAsCompleted(true);
          }}
          btn2onPressed={() => {
            // Optionally focus on the quiz button
            setShowAlertforIsGraded(false);
            setShowMarkAsCompleted(true);
          }}
        ></QuizPopUpLogout>
      )}
    </div>
  );
};

export default VideoPlayerV2Component;
